import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-note",
  "use": "icon-note-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-note\"><path fill=\"#ffffff\" d=\"M208.896 788.48l152.576-48.128c8.192-3.072 16.384-7.168 22.528-14.336l403.456-433.152c50.176-53.248 47.104-136.192-6.144-186.368-53.248-49.152-136.192-46.08-186.368 7.168L191.488 545.792c-6.144 7.168-10.24 15.36-12.288 23.552L142.336 727.04c-9.216 38.912 27.648 73.728 66.56 61.44z m423.936-640c29.696-31.744 80.896-33.792 112.64-4.096 31.744 29.696 33.792 80.896 4.096 112.64l-29.696 31.744-112.64-112.64 25.6-27.648zM229.376 581.632l343.04-367.616 112.64 112.64-338.944 363.52-152.576 48.128 35.84-156.672zM857.088 877.568H124.928c-14.336 0-25.6 11.264-25.6 25.6s11.264 25.6 25.6 25.6h732.16c14.336 0 25.6-11.264 25.6-25.6s-11.264-25.6-25.6-25.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/note.svg
// module id = yZSt
// module chunks = 57